import React from "react";
import { Table } from 'react-bootstrap';

const MyOrders = () => {
  const orders = [
    {
      sNo: 1,
      name: "John Doe",
      mobile: "123-456-7890",
      address: "123 Main St, Anytown, USA",
      orderName: "Product 1",
      orderPrice: "$50",
      orderStatus: "Delivered",
    },
    {
      sNo: 2,
      name: "Jane Smith",
      mobile: "987-654-3210",
      address: "456 Elm St, Othertown, USA",
      orderName: "Product 2",
      orderPrice: "$30",
      orderStatus: "Pending",
    },
    // Add more orders as needed
  ];
  return (
    <div className="dashboard-pages-padding">
      <h1>My All Orders</h1>
      <div className="tableDiv">
        <Table responsive>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Name</th>
              <th>Mobile</th>
              <th>Address</th>
              <th>Order Name</th>
              <th>Order Price</th>
              <th>Order Status</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order, index) => (
              <tr key={index}>
                <td>{order.sNo}</td>
                <td>{order.name}</td>
                <td>{order.mobile}</td>
                <td>{order.address}</td>
                <td>{order.orderName}</td>
                <td>{order.orderPrice}</td>
                <td>{order.orderStatus}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default MyOrders;
